module.exports = __webpack_public_path__ + "static/img/server19.edb4c9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/server19.png
// module id = lkCQ
// module chunks = 1